export default "__VITE_ASSET__DwsP3Sd0__"